<template>
  <div class="features" v-if="features.length">
    <div
      class="feature"
      :class="{ animated: animated }"
      v-for="f in features"
      :key="f.text"
    >
      <div class="img-wrap">
          <img :src="f.imageUrl" alt="share icon" />
        </div>
        {{ f.text }}
      </div>
    </div>
</template>

<script>
import {
  featuresByProgram
} from '@/shared/referral.js'
export default {
  props: {
    referralProgramType: {
      type: Number
    }
  },
  computed: {
    features () {
      return featuresByProgram(this.referralProgramType)
    }
  },
  mounted () {
    this.animation()
    setInterval(() => {
      this.animation()
    }, 6000)
  },
  methods: {
    animation () {
      this.animated = false
      this.timerId = setTimeout(() => {
        this.animated = true
        clearTimeout(this.timerId)
      }, 500)
    }
  },
  beforeDestroy () {
    if (this.timerId) {
      clearTimeout(this.timerId)
    }
  },
  data () {
    return {
      animated: false,
      timerId: null
    }
  }
}
</script>

<style scoped>
.features {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: start;
  align-items: flex-start;
  -ms-flex-pack: distribute;
  position: relative;
  width: 80%;
  margin: 35px auto;
  height: 53px;
  padding-bottom: 50px;
  max-width: 500px;
}

.features::after {
  content: "";
  display: block;
  width: 100%;
  height: 2px;
  background: #1e58ac;
  position: absolute;
  top: 26px;
  left: 0;
  right: 0;
  z-index: 0;
}

.feature {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #1e58ac;
  z-index: 1;
  position: absolute;
  transform: translateX(-50%);
  font-weight: 700;
  text-wrap: nowrap;

}

/* .feature.animated > .img-wrap {
  animation: 1s scale-up ease-in-out alternate;
  transform-origin: center;
} */

.feature:nth-child(1) {
  left: 0;
}

.feature:nth-child(2) {
  left: 50%;
}

.feature:nth-child(3) {
  left: 100%;
}

.feature > .img-wrap {
  position: relative;
  width: 40px;
  aspect-ratio: 1;
  border: 2px solid rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  margin-bottom: 15px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.feature > .img-wrap::before {
  position: absolute;
  left: 0;
  top: 50%;
  content: "";
  width: 10px;
  aspect-ratio: 1;
  border-style: solid;
  border-width: 2px;
  border-color: #1e58ac;
  border-top: transparent;
  border-left: transparent;
  transform: translate(calc((100% + 4px) * -1), -50%) rotate(-45deg);
  z-index: -1;
}


.feature > .img-wrap::after{
   position: absolute;
   z-index: -1;
   width: 100%;
   height: 100%;
   inset: 0;
   content:'';
   opacity: 0.8;
   visibility: visible;
   border-radius: inherit;
   border-color: #1e58ac;
   border-style: solid;
   border-width: 2px;
   box-sizing: border-box;
}

.feature.animated > .img-wrap::after{
  animation: pulse2 1s ease-in;
}

.feature.animated:nth-child(2) .img-wrap::after {
  animation-delay: 1s;
}

.feature.animated:nth-child(3) .img-wrap::after {
  animation-delay: 2s;
}

.features > .feature:first-of-type > .img-wrap::before {
  display: none;
}
</style>



// WEBPACK FOOTER //
// how-it-works-features.vue?381481c2